import React, { useEffect, useState } from 'react';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet.markercluster';
import 'leaflet.featuregroup.subgroup'; 
import InfoBox from '../../components/InfoBox';
 
const ClusterMap = ({combinedData}) => {

  const [showSidebar, setShowSidebar] = useState(true);

  const uniqueStates = [...new Set(combinedData.map((f) => f.state))];

  const generatePopUp = (data) => {
  return `
    <div style="
      max-width: 250px;
    ">
      <h2 style="font-size: 1rem; font-weight: bold; color: #166534; margin-bottom: 0.5rem;">👨‍🌾 Farmer Details</h2>
      <p><strong>👤 Name:</strong> ${data.farmerName}</p>
      <p><strong>👪 Guardian:</strong> ${data.fatherName}</p>
      <p><strong>🏡 Village:</strong> ${data.village}</p>
      <p><strong>🔁 Spray Cycle:</strong> ${data.sprayCycle}</p>
      <p><strong>📅 Date:</strong> ${data.dateOfSpraying}</p>
      <p><strong>🌱 Crop Stage:</strong> ${data.cropStage}</p>
      <p><strong>🦠 Pests/Diseases:</strong> ${data.pestDiseaseObserved}</p>
      <p><strong>🧪 Product:</strong> ${data.nameofproductsprayed}</p>
      <p><strong>💧 Dosage:</strong> ${data.dosage}</p>
      <p><strong>📏 Area Sprayed:</strong> ${data.areaSprayed} acres</p>
    </div>
  `;
};

  
  useEffect(() => {

    // 🛑 Prevent multiple map inits
    const existingMap = L.DomUtil.get('map');
    if (existingMap && existingMap._leaflet_id) {
      existingMap._leaflet_id = null;
    }


    const map = L.map('map').setView([20.59, 78.96], 5);

    const infoButton = L.control({ position: 'topleft' });

    infoButton.onAdd = function () {
      const div = L.DomUtil.create('div', 'leaflet-bar leaflet-control leaflet-control-custom');
      div.innerHTML = `<button id="toggleInfoBtn" title="Toggle Info" style="background: white; border: none; width: 30px; height: 30px; cursor: pointer;">
        ℹ️
      </button>`;
      return div;
    };

    infoButton.addTo(map);

            
    const customIcon = L.icon({
      iconUrl: "assets/placeholder.png",
      iconSize: [60, 60], // width, height
      iconAnchor: [15, 40], // point of the icon which will correspond to marker's location
      popupAnchor: [0, -40], // point from which the popup should open
    });

    L.tileLayer('http://mt0.google.com/vt/lyrs=y&hl=en&x={x}&y={y}&z={z}', {
      attribution: '&copy; OpenStreetMap contributors',
    }).addTo(map);

    // Create main cluster group
    const markerClusterGroup = L.markerClusterGroup();
    map.addLayer(markerClusterGroup);

    const overlays = {};

    for(let i=0; i<uniqueStates.length;i++){
      const subGroup = L.featureGroup.subGroup(markerClusterGroup);

      const filterByState = combinedData.filter((item) => item.state === uniqueStates[i]);
      for (let j = 0; j < filterByState.length; j++) {
        const item = filterByState[j];

        // Skip if coordinates are missing
        if (!item.latitude || !item.longitude) continue;

        const marker = L.marker([item.latitude, item.longitude], { icon: customIcon })
          .bindPopup(generatePopUp(item));

        subGroup.addLayer(marker);
      }


      overlays[uniqueStates[i]] = subGroup;
    }

    L.control.layers(null, overlays).addTo(map);

    setTimeout(() => {
      const toggleBtn = document.getElementById('toggleInfoBtn');
      if (toggleBtn) {
        toggleBtn.addEventListener('click', () => {
          setShowSidebar(prev => !prev);
        });
      }
    }, 100);
  }, []);

  return <div>
    <div id="map" style={{ height: '600px' , width : '100%'}} />
    {/* {showSidebar && (
      <div className={`absolute bottom-1 left-4 w-[300px] bg-white shadow-md p-4 z-[1000] transition-transform duration-300 bg-green-50 ${showSidebar ? 'translate-x-0' : 'translate-x-full'}`}>
      <InfoBox combinedData={combinedData} uniqueStates={uniqueStates}/>
    </div>
    )} */}
    </div>
};

export default ClusterMap;
